<script>
export default {
  props: ['order'],
  created() {
    if (typeof this.order === 'undefined') this.order = {};
  },
  computed: {
    user_role() {
      return this.$store.state.users.role;
    },
  },
  methods: {
    showEditModal() {
      this.$store.commit('set_instock_modal_order_products', this.order);
    },
    showEditOrderModal() {
      this.$store.commit('set_instock_modal_order_edit', this.order);
    },
    deleteOrder() {
      this.$store.commit('set_modal_inform', {
        type: 'delete',
        action: 'ib_delete_order',
        action_data: this.order.id,
      });
    },
    changeCondition(product) {
      this.$store.commit('set_instock_modal_asin', {
        order_id: this.order.id,
        product: product
      });
    },
  },
};
</script>
<template src="./order.pug" lang="pug"></template>
